import { render } from "./OutgoingCallLog.vue?vue&type=template&id=01a628e6&scoped=true"
import script from "./OutgoingCallLog.vue?vue&type=script&lang=js"
export * from "./OutgoingCallLog.vue?vue&type=script&lang=js"

import "./OutgoingCallLog.vue?vue&type=style&index=0&id=01a628e6&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a628e6"]])

export default __exports__